/* eslint-disable func-names */
import { PasswordValidatorRef } from "components/PasswordRequirements/interfaces";
import { RefObject } from "react";
import { TFunction } from "react-i18next";
import * as yup from "yup";
import { PasswordDefinitionFormValues } from "./interfaces";

export const initialValues: PasswordDefinitionFormValues = {
  newPassword: "",
  confirmedNewPassword: "",
};

export const getValidationSchema = (
  t: TFunction,
  passwordRef: RefObject<PasswordValidatorRef>
): yup.SchemaOf<PasswordDefinitionFormValues> =>
  yup.object().shape({
    newPassword: yup
      .string()
      .required(t("7893") /* O campo deverá ser preenchido */)
      .test(
        "password-requirements",
        t(
          "8154"
        ) /* O campo deverá preencher os requisitos apresentados abaixo */,
        function () {
          return passwordRef.current?.isValid() || false;
        }
      ),
    confirmedNewPassword: yup
      .string()
      .required(t("7893") /* O campo deverá ser preenchido */)
      .oneOf(
        [yup.ref("newPassword")],
        t(
          "7883"
        ) /* A Confirmação da Senha não corresponde com a Senha introduzida */
      ),
  });
